import { api } from '@/lib/api';
import type { ApiKey, ApiKeyCreateResponse, AuditLogResponse } from './types';

export async function listApiKeys(): Promise<ApiKey[]> {
  return api.get<ApiKey[]>('/v4/api-keys');
}

export async function createApiKey(data: {
  name: string;
  scopes: string[];
  rateLimitRpm?: number;
  expiresAt?: string | null;
}): Promise<ApiKeyCreateResponse> {
  return api.post<ApiKeyCreateResponse>('/v4/api-keys', data);
}

export async function updateApiKey(
  id: string,
  data: { name?: string; scopes?: string[]; rateLimitRpm?: number; expiresAt?: string | null },
): Promise<ApiKey> {
  return api.put<ApiKey>(`/v4/api-keys/${id}`, data);
}

export async function revokeApiKey(id: string): Promise<void> {
  await api.delete(`/v4/api-keys/${id}`);
}

export async function getAuditLog(params: {
  pageNumber?: number;
  pageLength?: number;
}): Promise<AuditLogResponse> {
  return api.get<AuditLogResponse>('/v4/api-keys/audit-log', params);
}

export async function getAvailableScopes(): Promise<{ value: string; label: string }[]> {
  return api.get<{ value: string; label: string }[]>('/v4/api-keys/scopes');
}
